import { render, staticRenderFns } from "./StatusPreApproveDetails.vue?vue&type=template&id=ad36d228&scoped=true&"
import script from "./StatusPreApproveDetails.vue?vue&type=script&lang=js&"
export * from "./StatusPreApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatusPreApproveDetails.vue?vue&type=style&index=0&id=ad36d228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad36d228",
  null
  
)

export default component.exports